import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

function NavBarButton({ text, route, tip, icon=null, func=null }) {

const [mouseOver, setMouseOver] = useState(false);
const navigate = useNavigate();
function handleClick() {
  if (func) {
    func();
  } else {
    navigate(route);
  }
}


return (
<li
style={{
  position: "relative",
  paddingBottom: 11,
  paddingTop: 13,
}}
class="navbar-list"
>
<a
  href={route}
  className="drop-down-navbar"
  style={{
    position: "relative",
    backgroundColor: "rgb(23, 55, 151,0.0)",
    border: "none",
    color: "white",
    textDecoration: "none",
    pointerEvents: "auto",
  }}
  onMouseOver={() => setMouseOver(true)}
  onMouseLeave={() => setMouseOver(false)}
>
  <nobr> {(icon && <FontAwesomeIcon icon={icon} />)} <span className="hide-on-mobile">{text}</span></nobr>
</a>
{mouseOver ? (
  <div class="tips-navbar" style={{ position: "absolute" }}>
   {tip}
  </div>
) : (
  <></>
)}
</li>
)}

export default NavBarButton;